export const TAKE_OPTIONS = [5, 10, 20, 50, 100];

export const SPOTLIGHT_TICKET_PREVIEW_COUNT = 3;

export const FRESHDESK_TICKET_FILTER_URLS = {
  new: 'https://idecon.freshdesk.com/a/tickets/filters/new',
  unresolved: 'https://idecon.freshdesk.com/a/tickets/filters/unresolved',
  overdue: 'https://idecon.freshdesk.com/a/tickets/filters/overdue',
  dueToday: 'https://idecon.freshdesk.com/a/tickets/filters/due_today',
  myOpenPending:
    'https://idecon.freshdesk.com/a/tickets/filters/search?orderBy=created_at&orderType=desc&q[]=agent%3Fis_in%3A%5B0%5D&q[]=status%3Fis_in%3A%5B0%5D&ref=all_tickets',
  todayCreated:
    'https://idecon.freshdesk.com/a/tickets/filters/search?orderBy=created_at&orderType=desc&q[]=created%3Fis_greater_than%3A%22today%22&ref=all_tickets',
  todayClosed:
    'https://idecon.freshdesk.com/a/tickets/filters/search?orderBy=created_at&orderType=desc&q[]=closed_at%3Fis_greater_than%3A%22today%22&ref=all_tickets',
} as const;
